import { render, staticRenderFns } from "./isvpsDetail.vue?vue&type=template&id=07b120a2&scoped=true&"
import script from "./isvpsDetail.vue?vue&type=script&lang=js&"
export * from "./isvpsDetail.vue?vue&type=script&lang=js&"
import style0 from "./isvpsDetail.vue?vue&type=style&index=0&id=07b120a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b120a2",
  null
  
)

export default component.exports